var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskicon13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#DCFCE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.475C16 23.6583 16.3958 24.675 17.1875 25.525C17.9792 26.375 18.9667 26.85 20.15 26.95L18.6 25.4L20 24L24 28L20 32L18.6 30.6L20.2 29C18.45 28.9 16.9792 28.225 15.7875 26.975C14.5958 25.725 14 24.2333 14 22.5C14 20.6833 14.6292 19.1458 15.8875 17.8875C17.1458 16.6292 18.6833 16 20.5 16H24V18H20.5C19.25 18 18.1875 18.4333 17.3125 19.3C16.4375 20.1667 16 21.225 16 22.475ZM26 29V27H34V29H26ZM26 23.5V21.5H34V23.5H26ZM26 18V16H34V18H26Z",
    fill: "#16A34A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskicon13);
export default __webpack_public_path__ + "static/media/taskicon13.851320f5dddcc76dc2cd548a4534e55b.svg";
export { ForwardRef as ReactComponent };